var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon && _vm.showing === "svg"
    ? _c(
        "div",
        {
          staticClass: "code-snippet-tab",
          attrs: {
            id: "code-snippet-svg",
            role: "tabpanel",
            "aria-labelledby": "tab-svg",
          },
        },
        [
          _vm.hasFullSvgSupport
            ? _c("div", { staticClass: "padding-top-sm padding-x-xl" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "code-snippet-secondary-tabs size-sm position-relative z-1",
                    staticStyle: {
                      "--list-style-type": "none",
                      "--padding-left": "0",
                      "--margin-bottom": "0",
                      "--button-padding":
                        "var(--spacing-2xs) var(--spacing-sm)",
                      "--button-border-radius": "0",
                      "--button-margin-bottom": "0",
                    },
                    attrs: { role: "tablist" },
                  },
                  _vm._l(_vm.options, function (option) {
                    return _c(
                      "li",
                      {
                        key: option,
                        staticStyle: { "--display": "inline-block" },
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "link flat block code-snippet-secondary-tab",
                            staticStyle: {
                              "--button-active-background": "transparent",
                            },
                            attrs: {
                              id: `tab-${_vm.sluggifyOption(option)}`,
                              type: "button",
                              role: "tab",
                              "aria-controls": `${_vm.sluggifyOption(option)}`,
                              "aria-selected":
                                _vm.sluggifyOption(option) === _vm.formatChoice,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showOption(option)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(option) + "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("owa-code-block", {
            attrs: {
              "add-highlighting": "",
              "allow-shadow-copy": "",
              "copy-text": "Copy Code Snippet",
              "custom-copy-icon": "faClone",
              "copy-tracking-event": "icon_svg_code_copy_button_click",
              "copy-tracking-params": {
                icon_name: _vm.icon.name,
                icon_style: _vm.styling.style,
                icon_family: _vm.styling.family,
                svg_format: _vm.formatChoice,
              },
              lang: "svg",
              code: _vm.snippet,
            },
          }),
          _vm._v(" "),
          _c("icon-code-snippet-links", {
            attrs: {
              "has-custom-styling": _vm.hasCustomStyling,
              links: _vm.svgLearnAboutLinks,
              "selected-style": _vm.styling.style,
              "major-version": _vm.majorVersion,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }